module.exports = __webpack_public_path__ + "img/Vector3.771af344.svg";